/** t201u: marks someone's primary building when they have several: a brand-yellow star with a thin black outline (an icon, never text). */
import { Star } from 'lucide-react';

export function PrimaryStar({ className = 'h-3.5 w-3.5' }: { className?: string }) {
  return (
    <span role="img" aria-label="Primary building" title="Primary building" data-testid="primary-star" className="inline-flex shrink-0">
      <Star className={className} fill="var(--color-brand-yellow)" stroke="#000" strokeWidth={1.5} aria-hidden />
    </span>
  );
}
